var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcomoonFreeProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 7H9C7.9 7 7 7.84375 7 8.875V25.125C7 26.1562 7.9 27 9 27H25C26.1 27 27 26.1562 27 25.125V8.875C27 7.84375 26.1 7 25 7ZM24.3333 24.5H9.66667V9.5H24.3333V24.5ZM12.3333 18.25H21.6667V19.5H12.3333V18.25ZM12.3333 20.75H21.6667V22H12.3333V20.75ZM13.6667 12.625C13.6668 12.3787 13.7186 12.1348 13.8192 11.9073C13.9198 11.6797 14.0673 11.473 14.2531 11.2989C14.439 11.1248 14.6596 10.9867 14.9023 10.8925C15.1451 10.7984 15.4053 10.7499 15.668 10.75C15.9307 10.7501 16.1909 10.7987 16.4336 10.893C16.6763 10.9873 16.8968 11.1256 17.0825 11.2998C17.2682 11.474 17.4155 11.6808 17.516 11.9084C17.6164 12.136 17.6681 12.3799 17.668 12.6262C17.6678 13.1237 17.4569 13.6007 17.0815 13.9523C16.7062 14.304 16.1973 14.5014 15.6667 14.5012C15.1361 14.5011 14.6272 14.3033 14.2522 13.9515C13.8771 13.5996 13.6665 13.1224 13.6667 12.625ZM17 14.5H14.3333C13.2333 14.5 12.3333 15.0625 12.3333 15.75V17H19V15.75C19 15.0625 18.1 14.5 17 14.5Z",
    fill: "#005DA8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    stroke: "#005DA8",
    strokeOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcomoonFreeProfile);
export default __webpack_public_path__ + "static/media/icomoon-free--profile.44c140823874b08770ffafaaffe2c8cb.svg";
export { ForwardRef as ReactComponent };